import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import content from "@/content/siteContent";

export default function WhatWeDoSection() {
  const ch = content.chapters.whatWeDo;
  return (
    <section id={ch.id} data-testid="chapter-what-we-do" className="relative mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionHeader num={ch.num} label={ch.label} />
      <Reveal>
        <h2 className="max-w-3xl font-heading text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
          {ch.headlineA}
          <span className="text-plz-orange">{ch.headlineAccent}</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-2">
        {ch.sides.map((side, i) => (
          <Reveal key={side.title} delay={0.12 * i} className="h-full">
            <div
              data-testid={i === 0 ? "pathway-dfy" : "pathway-portfolio"}
              className="spotlight-frame group h-full rounded-3xl bg-plz-surface/50 p-8 transition-[transform,background-color] duration-500 hover:-translate-y-1.5 hover:bg-plz-surface/80 lg:p-10"
            >
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-plz-orange">{side.eyebrow}</p>
              <h3 className="mt-4 font-heading text-xl font-semibold sm:text-2xl">{side.title}</h3>
              <p className="mt-4 text-base leading-relaxed text-plz-slate">{side.body}</p>
              <button
                data-testid={i === 0 ? "pathway-dfy-cta" : "pathway-portfolio-cta"}
                data-scroll-to={side.cta.target}
                className="mt-8 flex items-center gap-2 font-heading text-sm font-bold text-plz-orange transition-colors hover:text-plz-amber"
              >
                {side.cta.label}
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
